export default function DotTodoIcon({ className }: { className?: string }) {
  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="DotTodo"
    >
      <path
        d="M111.769 82.2733C120.466 82.2736 127.517 89.2638 127.517 97.8867C127.517 106.509 120.466 113.5 111.769 113.5C103.071 113.5 96.0208 106.51 96.0206 97.8867C96.0206 89.2636 103.071 82.2733 111.769 82.2733Z"
        fill="var(--brand, oklch(0.7072 0.1482 159.48))"
      />
      <path
        d="M94.2972 20.233C102.007 12.589 114.507 12.589 122.218 20.233C129.927 27.877 129.928 40.27 122.218 47.914L63.5992 106.03C56.1445 113.42 44.0582 113.42 36.6035 106.03L5.86544 75.5561C-1.95515 67.8026 -1.95515 55.2313 5.86544 47.4778C13.686 39.7244 26.3651 39.7245 34.1857 47.4778L50.5007 63.653L94.2972 20.233Z"
        fill="var(--brand, oklch(0.7072 0.1482 159.48))"
      />
    </svg>
  );
}
